const module = { name: 'shared/sharedShowtimes', exports: {} }; const exports = module.exports;



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { swig as swig } from 'require-core';



const Selectors = {
    BODY: 'shared-amenity-list-body',
    BTN: '.js-amenity-btn',
    MODAL: '#shared-amenity-list-modal',
}
function onClick() {
    const amenityGroup = JSON.parse(this.dataset.amenityGroup);
    const { amenities, amenityWithImage } = amenityGroup;
    document.getElementById(Selectors.BODY).innerHTML = swig.render('_sharedAmenityList', {
        ...amenityGroup,
        amenities: amenityWithImage ? amenities.filter(amenity => amenity.name !== amenityWithImage.name) : amenities,
    });
}
function init() {
    modal.init(Selectors.BTN, Selectors.MODAL);
    document.querySelectorAll(Selectors.BTN).forEach(btn => btn.addEventListener('click', onClick));
}
module.exports = {
    init,
};
export default module.exports;